import SourceList from './SourceList';

export default {
    list: 	SourceList
};
